import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";
import "./AddProject.css";

const AddProject = () => {
  const { register, handleSubmit, reset } = useForm();
  const onSubmit = (data) => {
    console.log(data);
    axios
      .post("https://radiant-meadow-70732.herokuapp.com/addProjects", data)
      .then((res) => {
        console.log(res);
        if (res.data.insertedId) {
          alert("Data added, Successfully!");
          reset();
        }
      });
  };
  return (
    <div className="add-project">
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          {...register("projectTitle", { required: true, maxLength: 40 })}
          placeholder="Project Title"
        />
        <input
          {...register("site", { required: true, maxLength: 60 })}
          placeholder="Live Site"
        />
        <input
          {...register("client", { required: true, maxLength: 200 })}
          placeholder="Client Side"
        />
        <input
          {...register("server", { required: true, maxLength: 200 })}
          placeholder="Server Side"
        />
        <input
          {...register("technologies", { required: true, maxLength: 200 })}
          placeholder="Used Technologies"
        />
        <textarea {...register("brief")} placeholder="Short Description" />
        <textarea {...register("description")} placeholder="Long Description" />

        <input {...register("img")} placeholder="image url" />
        <input {...register("detailImg1")} placeholder="Datail image url" />
        <input {...register("detailImg2")} placeholder="Datail image url" />
        <input {...register("detailImg3")} placeholder="Datail image url" />
        <input type="submit" className="bk-button" />
      </form>
    </div>
  );
};

export default AddProject;
